
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 12 12"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.708 1.274L9.97 4.282c.307.283.53.791.53 1.207V10a1 1 0 01-1.002 1H2.5a1 1 0 01-1-.999V5.49c0-.416.224-.924.53-1.207l3.262-3.008a1.053 1.053 0 011.416 0zm-.738.735L2.708 5.017a.826.826 0 00-.208.472V10H9.498v-.263l.001-.08.001-4.168a.824.824 0 00-.208-.472L6.03 2.01c-.013-.012-.047-.012-.06 0zm-.21 1.58a.566.566 0 01.43 0c.07.028.134.068.187.12l1.7 1.699a.566.566 0 010 .804.566.566 0 01-.805 0l-.73-.736v2.6a.566.566 0 01-1.133 0v-2.6l-.73.736a.569.569 0 01-.805-.804l1.7-1.7a.566.566 0 01.186-.118z"}})])
          )
        }
      }
    